/**
 * @fileoverview gRPC-Web generated client stub for no.jotta.openapi.file.v2
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v4.22.5
// source: no/jotta/openapi/file/file.v2.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var no_jotta_openapi_ping_pb = require('../../../../no/jotta/openapi/ping_pb.js')

var no_jotta_openapi_job_v1_job_v1_pb = require('../../../../no/jotta/openapi/job/v1/job.v1_pb.js')

var google_api_annotations_pb = require('../../../../google/api/annotations_pb.js')
const proto = {};
proto.no = {};
proto.no.jotta = {};
proto.no.jotta.openapi = {};
proto.no.jotta.openapi.file = {};
proto.no.jotta.openapi.file.v2 = require('./file.v2_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.no.jotta.openapi.file.v2.FileServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.no.jotta.openapi.file.v2.FileServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.file.v2.AllocateRequest,
 *   !proto.no.jotta.openapi.file.v2.AllocateResponse>}
 */
const methodDescriptor_FileService_Allocate = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.file.v2.FileService/Allocate',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.file.v2.AllocateRequest,
  proto.no.jotta.openapi.file.v2.AllocateResponse,
  /**
   * @param {!proto.no.jotta.openapi.file.v2.AllocateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.file.v2.AllocateResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.file.v2.AllocateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.file.v2.AllocateResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.file.v2.AllocateResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.file.v2.FileServiceClient.prototype.allocate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.file.v2.FileService/Allocate',
      request,
      metadata || {},
      methodDescriptor_FileService_Allocate,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.file.v2.AllocateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.file.v2.AllocateResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.file.v2.FileServicePromiseClient.prototype.allocate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.file.v2.FileService/Allocate',
      request,
      metadata || {},
      methodDescriptor_FileService_Allocate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.file.v2.CreateFolderRequest,
 *   !proto.no.jotta.openapi.file.v2.CreateFolderResponse>}
 */
const methodDescriptor_FileService_CreateFolder = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.file.v2.FileService/CreateFolder',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.file.v2.CreateFolderRequest,
  proto.no.jotta.openapi.file.v2.CreateFolderResponse,
  /**
   * @param {!proto.no.jotta.openapi.file.v2.CreateFolderRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.file.v2.CreateFolderResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.file.v2.CreateFolderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.file.v2.CreateFolderResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.file.v2.CreateFolderResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.file.v2.FileServiceClient.prototype.createFolder =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.file.v2.FileService/CreateFolder',
      request,
      metadata || {},
      methodDescriptor_FileService_CreateFolder,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.file.v2.CreateFolderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.file.v2.CreateFolderResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.file.v2.FileServicePromiseClient.prototype.createFolder =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.file.v2.FileService/CreateFolder',
      request,
      metadata || {},
      methodDescriptor_FileService_CreateFolder);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.file.v2.GetPathRequest,
 *   !proto.no.jotta.openapi.file.v2.GetPathResponse>}
 */
const methodDescriptor_FileService_GetPath = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.file.v2.FileService/GetPath',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.file.v2.GetPathRequest,
  proto.no.jotta.openapi.file.v2.GetPathResponse,
  /**
   * @param {!proto.no.jotta.openapi.file.v2.GetPathRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.file.v2.GetPathResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.file.v2.GetPathRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.file.v2.GetPathResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.file.v2.GetPathResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.file.v2.FileServiceClient.prototype.getPath =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.file.v2.FileService/GetPath',
      request,
      metadata || {},
      methodDescriptor_FileService_GetPath,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.file.v2.GetPathRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.file.v2.GetPathResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.file.v2.FileServicePromiseClient.prototype.getPath =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.file.v2.FileService/GetPath',
      request,
      metadata || {},
      methodDescriptor_FileService_GetPath);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.file.v2.CopyRequest,
 *   !proto.no.jotta.openapi.file.v2.CopyResponse>}
 */
const methodDescriptor_FileService_Copy = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.file.v2.FileService/Copy',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.file.v2.CopyRequest,
  proto.no.jotta.openapi.file.v2.CopyResponse,
  /**
   * @param {!proto.no.jotta.openapi.file.v2.CopyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.file.v2.CopyResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.file.v2.CopyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.file.v2.CopyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.file.v2.CopyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.file.v2.FileServiceClient.prototype.copy =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.file.v2.FileService/Copy',
      request,
      metadata || {},
      methodDescriptor_FileService_Copy,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.file.v2.CopyRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.file.v2.CopyResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.file.v2.FileServicePromiseClient.prototype.copy =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.file.v2.FileService/Copy',
      request,
      metadata || {},
      methodDescriptor_FileService_Copy);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.file.v2.MoveRequest,
 *   !proto.no.jotta.openapi.file.v2.MoveResponse>}
 */
const methodDescriptor_FileService_Move = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.file.v2.FileService/Move',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.file.v2.MoveRequest,
  proto.no.jotta.openapi.file.v2.MoveResponse,
  /**
   * @param {!proto.no.jotta.openapi.file.v2.MoveRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.file.v2.MoveResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.file.v2.MoveRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.file.v2.MoveResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.file.v2.MoveResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.file.v2.FileServiceClient.prototype.move =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.file.v2.FileService/Move',
      request,
      metadata || {},
      methodDescriptor_FileService_Move,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.file.v2.MoveRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.file.v2.MoveResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.file.v2.FileServicePromiseClient.prototype.move =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.file.v2.FileService/Move',
      request,
      metadata || {},
      methodDescriptor_FileService_Move);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.file.v2.DeleteRequest,
 *   !proto.no.jotta.openapi.file.v2.DeleteResponse>}
 */
const methodDescriptor_FileService_Delete = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.file.v2.FileService/Delete',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.file.v2.DeleteRequest,
  proto.no.jotta.openapi.file.v2.DeleteResponse,
  /**
   * @param {!proto.no.jotta.openapi.file.v2.DeleteRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.file.v2.DeleteResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.file.v2.DeleteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.file.v2.DeleteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.file.v2.DeleteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.file.v2.FileServiceClient.prototype.delete =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.file.v2.FileService/Delete',
      request,
      metadata || {},
      methodDescriptor_FileService_Delete,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.file.v2.DeleteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.file.v2.DeleteResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.file.v2.FileServicePromiseClient.prototype.delete =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.file.v2.FileService/Delete',
      request,
      metadata || {},
      methodDescriptor_FileService_Delete);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.file.v2.RestoreRequest,
 *   !proto.no.jotta.openapi.file.v2.RestoreResponse>}
 */
const methodDescriptor_FileService_Restore = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.file.v2.FileService/Restore',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.file.v2.RestoreRequest,
  proto.no.jotta.openapi.file.v2.RestoreResponse,
  /**
   * @param {!proto.no.jotta.openapi.file.v2.RestoreRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.file.v2.RestoreResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.file.v2.RestoreRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.file.v2.RestoreResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.file.v2.RestoreResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.file.v2.FileServiceClient.prototype.restore =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.file.v2.FileService/Restore',
      request,
      metadata || {},
      methodDescriptor_FileService_Restore,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.file.v2.RestoreRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.file.v2.RestoreResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.file.v2.FileServicePromiseClient.prototype.restore =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.file.v2.FileService/Restore',
      request,
      metadata || {},
      methodDescriptor_FileService_Restore);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.file.v2.DeletePermanentlyRequest,
 *   !proto.no.jotta.openapi.file.v2.DeletePermanentlyResponse>}
 */
const methodDescriptor_FileService_DeletePermanently = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.file.v2.FileService/DeletePermanently',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.file.v2.DeletePermanentlyRequest,
  proto.no.jotta.openapi.file.v2.DeletePermanentlyResponse,
  /**
   * @param {!proto.no.jotta.openapi.file.v2.DeletePermanentlyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.file.v2.DeletePermanentlyResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.file.v2.DeletePermanentlyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.file.v2.DeletePermanentlyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.file.v2.DeletePermanentlyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.file.v2.FileServiceClient.prototype.deletePermanently =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.file.v2.FileService/DeletePermanently',
      request,
      metadata || {},
      methodDescriptor_FileService_DeletePermanently,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.file.v2.DeletePermanentlyRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.file.v2.DeletePermanentlyResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.file.v2.FileServicePromiseClient.prototype.deletePermanently =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.file.v2.FileService/DeletePermanently',
      request,
      metadata || {},
      methodDescriptor_FileService_DeletePermanently);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.file.v2.ListRevisionsRequest,
 *   !proto.no.jotta.openapi.file.v2.ListRevisionsResponse>}
 */
const methodDescriptor_FileService_ListRevisions = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.file.v2.FileService/ListRevisions',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.file.v2.ListRevisionsRequest,
  proto.no.jotta.openapi.file.v2.ListRevisionsResponse,
  /**
   * @param {!proto.no.jotta.openapi.file.v2.ListRevisionsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.file.v2.ListRevisionsResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.file.v2.ListRevisionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.file.v2.ListRevisionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.file.v2.ListRevisionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.file.v2.FileServiceClient.prototype.listRevisions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.file.v2.FileService/ListRevisions',
      request,
      metadata || {},
      methodDescriptor_FileService_ListRevisions,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.file.v2.ListRevisionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.file.v2.ListRevisionsResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.file.v2.FileServicePromiseClient.prototype.listRevisions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.file.v2.FileService/ListRevisions',
      request,
      metadata || {},
      methodDescriptor_FileService_ListRevisions);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.file.v2.SearchRequest,
 *   !proto.no.jotta.openapi.file.v2.SearchResponse>}
 */
const methodDescriptor_FileService_Search = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.file.v2.FileService/Search',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.no.jotta.openapi.file.v2.SearchRequest,
  proto.no.jotta.openapi.file.v2.SearchResponse,
  /**
   * @param {!proto.no.jotta.openapi.file.v2.SearchRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.file.v2.SearchResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.file.v2.SearchRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.file.v2.SearchResponse>}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.file.v2.FileServiceClient.prototype.search =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/no.jotta.openapi.file.v2.FileService/Search',
      request,
      metadata || {},
      methodDescriptor_FileService_Search);
};


/**
 * @param {!proto.no.jotta.openapi.file.v2.SearchRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.file.v2.SearchResponse>}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.file.v2.FileServicePromiseClient.prototype.search =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/no.jotta.openapi.file.v2.FileService/Search',
      request,
      metadata || {},
      methodDescriptor_FileService_Search);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.file.v2.RecentFilesRequest,
 *   !proto.no.jotta.openapi.file.v2.RecentFilesResponse>}
 */
const methodDescriptor_FileService_RecentFiles = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.file.v2.FileService/RecentFiles',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.file.v2.RecentFilesRequest,
  proto.no.jotta.openapi.file.v2.RecentFilesResponse,
  /**
   * @param {!proto.no.jotta.openapi.file.v2.RecentFilesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.file.v2.RecentFilesResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.file.v2.RecentFilesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.file.v2.RecentFilesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.file.v2.RecentFilesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.file.v2.FileServiceClient.prototype.recentFiles =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.file.v2.FileService/RecentFiles',
      request,
      metadata || {},
      methodDescriptor_FileService_RecentFiles,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.file.v2.RecentFilesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.file.v2.RecentFilesResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.file.v2.FileServicePromiseClient.prototype.recentFiles =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.file.v2.FileService/RecentFiles',
      request,
      metadata || {},
      methodDescriptor_FileService_RecentFiles);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.file.v2.DownloadZipRequest,
 *   !proto.no.jotta.openapi.file.v2.DownloadZipResponse>}
 */
const methodDescriptor_FileService_DownloadZip = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.file.v2.FileService/DownloadZip',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.file.v2.DownloadZipRequest,
  proto.no.jotta.openapi.file.v2.DownloadZipResponse,
  /**
   * @param {!proto.no.jotta.openapi.file.v2.DownloadZipRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.file.v2.DownloadZipResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.file.v2.DownloadZipRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.file.v2.DownloadZipResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.file.v2.DownloadZipResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.file.v2.FileServiceClient.prototype.downloadZip =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.file.v2.FileService/DownloadZip',
      request,
      metadata || {},
      methodDescriptor_FileService_DownloadZip,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.file.v2.DownloadZipRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.file.v2.DownloadZipResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.file.v2.FileServicePromiseClient.prototype.downloadZip =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.file.v2.FileService/DownloadZip',
      request,
      metadata || {},
      methodDescriptor_FileService_DownloadZip);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.file.v2.ListFolderRequest,
 *   !proto.no.jotta.openapi.file.v2.ListFolderResponse>}
 */
const methodDescriptor_FileService_ListFolder = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.file.v2.FileService/ListFolder',
  grpc.web.MethodType.UNARY,
  proto.no.jotta.openapi.file.v2.ListFolderRequest,
  proto.no.jotta.openapi.file.v2.ListFolderResponse,
  /**
   * @param {!proto.no.jotta.openapi.file.v2.ListFolderRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.file.v2.ListFolderResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.file.v2.ListFolderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.file.v2.ListFolderResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.file.v2.ListFolderResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.file.v2.FileServiceClient.prototype.listFolder =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.file.v2.FileService/ListFolder',
      request,
      metadata || {},
      methodDescriptor_FileService_ListFolder,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.file.v2.ListFolderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.file.v2.ListFolderResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.file.v2.FileServicePromiseClient.prototype.listFolder =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.file.v2.FileService/ListFolder',
      request,
      metadata || {},
      methodDescriptor_FileService_ListFolder);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.file.v2.ListFolderStreamRequest,
 *   !proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse>}
 */
const methodDescriptor_FileService_ListFolderStream = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.file.v2.FileService/ListFolderStream',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.no.jotta.openapi.file.v2.ListFolderStreamRequest,
  proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse,
  /**
   * @param {!proto.no.jotta.openapi.file.v2.ListFolderStreamRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.file.v2.ListFolderStreamRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse>}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.file.v2.FileServiceClient.prototype.listFolderStream =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/no.jotta.openapi.file.v2.FileService/ListFolderStream',
      request,
      metadata || {},
      methodDescriptor_FileService_ListFolderStream);
};


/**
 * @param {!proto.no.jotta.openapi.file.v2.ListFolderStreamRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.file.v2.ListFolderItemStreamResponse>}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.file.v2.FileServicePromiseClient.prototype.listFolderStream =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/no.jotta.openapi.file.v2.FileService/ListFolderStream',
      request,
      metadata || {},
      methodDescriptor_FileService_ListFolderStream);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.no.jotta.openapi.PingRequest,
 *   !proto.no.jotta.openapi.PingResponse>}
 */
const methodDescriptor_FileService_Ping = new grpc.web.MethodDescriptor(
  '/no.jotta.openapi.file.v2.FileService/Ping',
  grpc.web.MethodType.UNARY,
  no_jotta_openapi_ping_pb.PingRequest,
  no_jotta_openapi_ping_pb.PingResponse,
  /**
   * @param {!proto.no.jotta.openapi.PingRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  no_jotta_openapi_ping_pb.PingResponse.deserializeBinary
);


/**
 * @param {!proto.no.jotta.openapi.PingRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.no.jotta.openapi.PingResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.no.jotta.openapi.PingResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.no.jotta.openapi.file.v2.FileServiceClient.prototype.ping =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/no.jotta.openapi.file.v2.FileService/Ping',
      request,
      metadata || {},
      methodDescriptor_FileService_Ping,
      callback);
};


/**
 * @param {!proto.no.jotta.openapi.PingRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.no.jotta.openapi.PingResponse>}
 *     Promise that resolves to the response
 */
proto.no.jotta.openapi.file.v2.FileServicePromiseClient.prototype.ping =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/no.jotta.openapi.file.v2.FileService/Ping',
      request,
      metadata || {},
      methodDescriptor_FileService_Ping);
};


module.exports = proto.no.jotta.openapi.file.v2;

